import { addLiveNotification } from "../redux/notifications/slice.js";
const VITE_WSS_URL = import.meta.env.VITE_WSS_URL;

export function createNotificationsSocket(token, dispatch) {
  let socket;
  let isClosed = false;

  function connect() {
    socket = new WebSocket(
      `${VITE_WSS_URL}/api/v1/notifications/ws?token=${token}`
    );

    socket.onopen = () => {
      console.log("WebSocket відкрито");
    };

    socket.onmessage = event => {
      try {
        const notification = JSON.parse(event.data);
        console.log("Отримано сповіщення:", notification);
        dispatch(addLiveNotification(notification.notification));
      } catch {
        // ignore malformed messages
      }
    };

    socket.onclose = () => {
      if (!isClosed) {
        setTimeout(connect, 3000);
      }
    };

    socket.onerror = () => {
      socket.close();
    };
  }

  connect();

  return {
    close: () => {
      isClosed = true;
      socket?.close();
    },
  };
}
